import React from 'react';
import UserList from '../../components/users/UserList';

const UserListPage: React.FC = () => {
  return <UserList />;
};

export default UserListPage;